import { Component, ViewChild, Injector } from '@angular/core';
import { Table } from 'primeng/table';
import { HostDashboardServiceProxy, GetRecentTenantsOutput } from '@shared/service-proxies/service-proxies';
import { WidgetComponentBaseComponent } from '../widget-component-base';
import { AppConsts } from '@shared/AppConsts';
import { AppRoutes } from '@app/shared/routes/app-routes';

@Component({
  standalone: false,
  selector: 'app-widget-recent-tenants',
  templateUrl: './widget-recent-tenants.component.html',
  styleUrls: ['./widget-recent-tenants.component.css']
})
export class WidgetRecentTenantsComponent extends WidgetComponentBaseComponent {
  @ViewChild('RecentTenantsTable', { static: true }) recentTenantsTable: Table;
  constructor(injector: Injector,
    private _hostDashboardServiceProxy: HostDashboardServiceProxy) {
    super(injector);
    this.loadRecentTenantsData();
  }

  loading = true;

  recentTenantsData: GetRecentTenantsOutput;

  loadRecentTenantsData() {
    this._hostDashboardServiceProxy.getRecentTenantsData().subscribe((data) => {
      this.recentTenantsData = data;
      this.loading = false;
      this.markForCheck();
    });
  }

  gotoAllRecentTenants(): void {
    window.open(`${AppConsts.appBaseUrl}${AppRoutes.admin.tenants}?` +
      'creationDateStart=' + encodeURIComponent(this.recentTenantsData.tenantCreationStartDate.toString()), '_blank');
  }

}
